import { MaxFileSizeIndicatorText } from "@/components/common/Uploader/MaxFileSizeIndicator/MaxFileSizeIndicatorText";
import { Translate } from "components/common/Translate/Translate";
import { AddImages } from "../ControlBar/AddImages/AddImages";
import { DeleteAll } from "../ControlBar/DeleteAll/DeleteAll";
import { Sort } from "../ControlBar/Sort/Sort";
import { DownloadAll } from "./DownloadAll/DownloadAll";
import { NoImages } from "./NoImages/NoImages";
import { PreviewList } from "./PreviewList/PreviewList";
import { usePreview } from "./usePreview";

export const Preview = () => {
    const { images, selectedImageId } = usePreview();

    return (
        <div className="relative flex flex-col justify-between h-full">
            <div className="flex-shrink-0 flex flex-col justify-center gap-2  border-b border-b-irGray-200 dark:border-b-darkSurface-600 px-4 h-[101px]">
                <div className="flex-shrink-0 flex items-center justify-between gap-4">
                    <AddImages />
                    {images.length > 0 && (
                        <div className="flex items-center gap-4">
                            <DeleteAll />
                            <Sort />
                        </div>
                    )}
                </div>
                <MaxFileSizeIndicatorText />
            </div>

            <div className="w-full text-lg">
                {images.length === 0 && (
                    <div className="p-4">
                        <NoImages />
                    </div>
                )}
                {selectedImageId === null && images.length !== 0 && (
                    <div className="p-4" data-testid="no-selected-image-text">
                        <Translate keyName="no-selected-images-helper-text" />
                    </div>
                )}
            </div>
            <div className="w-full flex-grow scroll overflow-x-hidden">
                <PreviewList />
            </div>
            <DownloadAll />
        </div>
    );
};
